import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase6 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                { date: '2025-04-28', revenue_net_pln: 2059551.21 },
                { date: '2025-05-05', revenue_net_pln: 2145646.52 },
                { date: '2025-05-12', revenue_net_pln: 2111534.61 },
                { date: '2025-05-19', revenue_net_pln: 1871792.34 },
                { date: '2025-05-26', revenue_net_pln: 1901750.8 },
                { date: '2025-06-02', revenue_net_pln: 1852905.45 },
                { date: '2025-06-09', revenue_net_pln: 1802935.24 },
                { date: '2025-06-16', revenue_net_pln: 1763906.09 },
                { date: '2025-06-23', revenue_net_pln: 1537308.46 },
                { date: '2025-06-30', revenue_net_pln: 1502427.75 },
                { date: '2025-07-07', revenue_net_pln: 1559519.88 },
                { date: '2025-07-14', revenue_net_pln: 1550177.14 },
                { date: '2025-07-21', revenue_net_pln: 1503579.67 },
                { date: '2025-07-28', revenue_net_pln: 1582899.23 },
                { date: '2025-08-04', revenue_net_pln: 1630788.48 },
                { date: '2025-08-11', revenue_net_pln: 1609489.62 },
                { date: '2025-08-18', revenue_net_pln: 1507310.98 },
                { date: '2025-08-25', revenue_net_pln: 1591868.99 },
                { date: '2025-09-01', revenue_net_pln: 1615830.47 },
                { date: '2025-09-08', revenue_net_pln: 1496414.9 },
                { date: '2025-09-15', revenue_net_pln: 1548962.19 },
                { date: '2025-09-22', revenue_net_pln: 621804.95 },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
